import type { Category, CategoryInput } from '@shop-monorepo/types';
import React from 'react';

import { useUpdateCategory } from '../../hooks/useCategoryQueries';
import { useListReturn } from '../../hooks/useListReturn';
import { ROUTES } from '../../routes/routes';

import { CategoryForm } from './CategoryForm';

interface EditCategoryFormProps {
  category: Category;
  parentCategories: Category[];
  hasChildren: boolean;
}

export const EditCategoryForm: React.FC<EditCategoryFormProps> = ({
  category,
  parentCategories,
  hasChildren,
}) => {
  const { goToList } = useListReturn(ROUTES.CATEGORIES);
  const { mutate: updateCategory, isPending: isSubmitting } = useUpdateCategory();

  const handleSubmit = async (values: CategoryInput) => {
    updateCategory(
      { id: category.id, category: values },
      {
        onSuccess: () => {
          goToList();
        },
      },
    );
  };

  // Disable parent select if category is a root with children
  const disableParentSelect = hasChildren && category.parentId === null;

  return (
    <CategoryForm
      initialValues={category}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      parentCategories={parentCategories}
      disableParentSelect={disableParentSelect}
    />
  );
};
